export default "__VITE_ASSET__gJ0UMkc5__"